export default "__VITE_ASSET__DNtyFt81__"